/**
 * Canonical constants. Anything user-visible here traces to an approved decision.
 * Copy is verbatim from the Voice Guide — receiver voice on the R27, Codi voice
 * elsewhere; the two never blend (ENG-060).
 */

/** ENG-075 — the sole public domain. No other domain appears anywhere in this project. */
export const PUBLIC_DOMAIN = 'codeinecoding.io' as const;

/** ENG-045/046 — one canonical designation, shown on the bezel. */
export const RECEIVER_DESIGNATION = 'R27' as const;

/**
 * ENG-076 — naming layers.
 * `BROADCAST_ID` is the machine identifier (ENG-050) and is never displayed.
 * `BROADCAST_PUBLIC_NAME` is what the visitor reads.
 */
export const BROADCAST_ID = 'codeinecoding.galactic-public-access' as const;
export const BROADCAST_PUBLIC_NAME = 'CHANNEL ONE' as const;

/** W1 §5 — the Hero Knob force for Broadcast #1. */
export const HERO_FORCE_LABEL = 'DRIFT' as const;

/** Voice Guide §3 — receiver voice. Uppercase readouts, no apology, no software vocabulary. */
export const RECEIVER_COPY = {
  noSignal: 'NO SIGNAL',
  noBroadcasts: 'NO BROADCASTS',
  acquiring: 'ACQUIRING',
  signalLost: 'SIGNAL LOST',
} as const;

/** Voice Guide §5 — Codi voice. Warm, concise, never on the R27's readouts. */
export const CODI_COPY = {
  nativeComingSoon: 'Native plugins for macOS and Windows — Coming Soon',
} as const;
